import React from 'react';
import { MainWrapper } from 'src/domains/layouts/layouts/homepage/Homepage.style';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { PromotedEventsWidget } from 'src/domains/sportsbook/shared/Components';
import { observer } from 'src/utils/mobx-react';
import { PromotedEventsRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { SeoPagesContent } from 'src/domains/layouts/webview/components/seoPages/SeoPages';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

interface PropsType {
    currentView: PromotedEventsRouteType;
    accountView: RightHandSideViewType | null;
    isSearchActive: boolean;
}

export const PromotedEvents = observer('PromotedEvents', ({ currentView, accountView, isSearchActive }: PropsType) => {
    const common = useCommon();
    const { promotedEventsState } = AppLayoutsState.get(common);

    return (
        <MainWrapper className='homepage'>
            <LayoutSkeleton
                currentView={currentView}
                accountView={accountView}
                isSearchActive={isSearchActive}
                navigationType='global'
            >
                <>
                    <PromotedEventsWidget
                        promotedEventsState={promotedEventsState}
                        topMargin={true}
                    />
                    <SeoPagesContent pageSlug='promoted-events' />
                </>
            </LayoutSkeleton>
        </MainWrapper>
    );
});
